module.exports = __webpack_public_path__ + "img/HörNix.018e6bd9.svg";